// extracted by mini-css-extract-plugin
export default {"productVideo":"productvideo_productVideo__KuTCl","cover":"productvideo_cover__j6GBV","play":"productvideo_play__TyESR"};